var map = {
	"./top1.png": "6eaa",
	"./top2.png": "9e7e",
	"./top3.png": "9597",
	"./top_tip_ico.png": "ec7d",
	"./topfontbg.png": "87d4",
	"./topfontlt.png": "c651",
	"./topfontrt.png": "44d5",
	"./topic_icon.png": "d6a5",
	"./topic_icon2.png": "f4e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0eb6";